import React from 'react';
import './BetaCtaButton.css';
import Button from './Button';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Beta CTA Button — Issue #423
 *
 * Header CTA that labels itself "Beta" and navigates to the top of the
 * beta-test page. Built as a thin wrapper over the shared <Button> so it
 * inherits the website's standard CTA design (primary variant).
 *
 * This component is only relevant during the beta-test phase. To remove it
 * completely after beta:
 *   1. Delete this file and BetaCtaButton.css
 *   2. Remove the BetaCtaButton import/export from shared/index.js
 *   3. Remove the BetaCtaButton render and onBetaClick prop in Header.js
 *   4. Remove onBetaClick wiring in App.js and pages/BetaTestPage.js
 *   5. Remove the `header.betaCta` / `a11y.betaCtaLabel` translation keys
 *
 * @param {function} onClick - Callback invoked when the user activates the CTA
 */
const BetaCtaButton = ({ onClick }) => {
  const { t } = useLanguage();

  return (
    <Button
      variant="primary"
      size="small"
      showIcon={false}
      ariaLabel={t('a11y.betaCtaLabel')}
      onClick={onClick}
      className="beta-cta-button"
    >
      {t('header.betaCta')}
    </Button>
  );
};

export default BetaCtaButton;
